import { ChangeDetectionStrategy, Component, inject, input, signal } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { PrismicDocument } from '@prismicio/client';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { switchMap, tap } from 'rxjs';
import { ActionCardComponent } from 'action-card';
import { CategoryService } from '../category.service';
import { SupportCategory } from '../support-types';
import { transformSupportDocLink } from '../transform-support-doc-link';

@Component({
  selector: 'app-categories-list',
  templateUrl: './categories-list.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ActionCardComponent, NgxSkeletonLoaderModule],
})
export class CategoriesListComponent {
  protected readonly transformCardLink = transformSupportDocLink;
  public readonly category = input<PrismicDocument<SupportCategory>>();
  private categoryService = inject(CategoryService);
  public readonly subCategoriesTree = toSignal(
    toObservable(this.category).pipe(
      tap(() => this.loading.set(true)),
      switchMap(category => this.categoryService.findSubCategories(category)),
      tap(() => this.loading.set(false))
    )
  );
  public loading = signal(false);
}
